import { FC, Suspense, lazy } from 'react';

import styles from './styles.scss';

const PaddleIcon = lazy(
    () => import(/* webpackChunkName: "PaddleIcon" */ 'dibs-icons/exports/Paddle')
);

const isClient = typeof window !== 'undefined' && window.document;

export const PricePaddleIcon: FC = () => {
    return (
        <div className={styles.paddleContainer}>
            {isClient && (
                <Suspense fallback={null}>
                    <PaddleIcon className={styles.paddle} />
                </Suspense>
            )}
        </div>
    );
};
